import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '../../shared/Header/header.vue';
import { Models } from '../../models/models';
import Skittle from '../../shared/Skittle/skittle.vue';
import { SkittleManager } from '../../services/skittle.manager';
import * as T_T from 'cryface';

@Component({
   components: {
      Header,
      Skittle
   }
})
export default class SkittlesPage extends Vue {
   public title: string = 'SkittlesPage';

   public skittleGroups: Models.IKeyValue<string[]>[] = [];

   public skittleManager: SkittleManager = new SkittleManager();

   @Watch('$store.state.auth.menuList', { immediate: true, deep: true })
   public onMenuListGotten(val: any, oldVal: any) {
      const menuAll: Models.IKeyValue<string[]>[] = this.skittleManager.groups;
      if (T_T.simpleDetect(val)) {
         val.map((v: any) => {
            menuAll.map((p: Models.IKeyValue<string[]>) => {
               if (p.value.indexOf(v.x_name_en.trim()) > -1) {
                  const currentGroup = this.skittleGroups.find((g: Models.IKeyValue<string[]>) => g.key === p.key);
                  if (T_T.simpleDetect(currentGroup)) {
                     currentGroup!.value.push(v.x_name_en.trim());
                  } else {
                     this.skittleGroups.push({
                        key: p.key,
                        value: [v.x_name_en.trim()],
                     });
                  }
               }
            });
         });
      }
   }
}
